import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { initLenis, destroyLenis } from "../lib/lenis";
import { DEFAULT_SETTINGS } from "../lib/constants";
import { SettingsCtx } from "../lib/SettingsContext";
import { Navbar } from "../components/landing/Navbar";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Services } from "../components/landing/Services";
import { HowItWorks } from "../components/landing/HowItWorks";
import { Emergency } from "../components/landing/Emergency";
import { Areas } from "../components/landing/Areas";
import { TireWizard } from "../components/landing/TireWizard";
import { Gallery } from "../components/landing/Gallery";
import { Reviews } from "../components/landing/Reviews";
import { Contact } from "../components/landing/Contact";
import { Footer } from "../components/landing/Footer";
import { StickyBar } from "../components/landing/StickyBar";
import { RequestModal } from "../components/landing/RequestModal";

export default function Landing() {
  const [services, setServices] = useState([]);
  const [areas, setAreas] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [req, setReq] = useState({ open: false, prefill: {} });

  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        const [s, a, r, g, st] = await Promise.all([
          api.get("/services"),
          api.get("/areas"),
          api.get("/reviews"),
          api.get("/gallery"),
          api.get("/settings"),
        ]);
        setServices(s.data);
        setAreas(a.data);
        setReviews(r.data);
        setGallery(g.data);
        setSettings({ ...DEFAULT_SETTINGS, ...st.data });
      } catch (e) {
        console.error("فشل تحميل بيانات الموقع", e);
      }
    };
    load();
  }, []);

  const openRequest = (prefill = {}) => setReq({ open: true, prefill });

  return (
    <SettingsCtx.Provider value={settings}>
      <div data-testid="landing-page" className="bg-[#0A0A0A] text-zinc-100 min-h-screen pb-20 md:pb-0 overflow-x-hidden">
        <Navbar />
        <Hero onRequest={openRequest} />
        <Marquee />
        <Services services={services} onRequest={openRequest} />
        <HowItWorks />
        <Emergency />
        <Areas areas={areas} />
        <TireWizard services={services} onRequest={openRequest} />
        <Gallery items={gallery} />
        <Reviews reviews={reviews} />
        <Contact />
        <Footer />
        <StickyBar onRequest={openRequest} />
        <RequestModal
          open={req.open}
          prefill={req.prefill}
          services={services}
          areas={areas}
          onClose={() => setReq({ open: false, prefill: {} })}
        />
      </div>
    </SettingsCtx.Provider>
  );
}
